import { getWildcardTextMaximum } from '../../../components/video';

import { PublicEvent } from '../../../types';

// GENERAl

export const getTipsList = () => {
  const tipsList = [
    'We’ve detected a face and analysing over a million data points. Hey there, good lookin',
    'Your file is currently taking a scenic route through cyberspace. Somewhere in a parallel universe, you are a star!',
    'We’re now soaring through the digital realm like paper airplanes and hopefully won’t get stuck on virtual trees',
    'Uploading a file is like pilates for processors',
    'Encrypting your data before sending it to space',
    'Our digital squirrels are working hard to store your files in the acorn-shaped cloud',
  ];

  return tipsList;
};

// PHOTO STAGE

export const getSelfieInfoPoints = () => {
  const selfieInfoPoints = [
    'No hats, sunglasses or masks',
    'Should only include <b>one person</b> in the photo',
    'Should be taken as close as possible to include head and shoulder only',
    'Face should be clearly shown and not blurry',
    'Use high resolution image with good lighting',
    'Your image is in JPEG, JPG, PNG, BMP or GIF format',
  ];

  return selfieInfoPoints;
};

// VIDEO STAGE

export const getUgcInfoPoints = (
  event: PublicEvent,
  requiredShots: number[],
) => {
  const ugcInfoPoints = [
    'Upload at least ' +
      getWildcardTextMaximum(requiredShots, 'video', 'around'),
    `Make sure to record videos in <b>${event.videoMode} orientation</b>`,
    'Your videos are in MP4 or MOV format',
  ];

  return ugcInfoPoints;
};
